"use strict";
exports.__esModule = true;
exports.makeSearchCard = exports.makeHeaderBanner = void 0;
var crypto_1 = require("crypto");
var types_1 = require("../types");
var makeHeaderBanner = function (override) {
    var id = new Date().getTime();
    var _a = (override !== null && override !== void 0 ? override : {}).code, code = _a === void 0 ? "code-".concat(id) : _a;
    return {
        id: "id-".concat(id),
        code: code,
        title: "title-".concat(id),
        hidden: !(0, crypto_1.randomInt)(0, 1),
        style: 'default',
        termsConditions: "termsConditions-".concat(id),
        buttonLink: "buttonLink-".concat(id),
        buttonHidden: !(0, crypto_1.randomInt)(0, 1),
        buttonMessage: "buttonMessage-".concat(id),
        promotionType: types_1.PromotionTypes.HeaderBanner
    };
};
exports.makeHeaderBanner = makeHeaderBanner;
var makeSearchCard = function (override) {
    var id = new Date().getTime();
    var _a = (override !== null && override !== void 0 ? override : {}).code, code = _a === void 0 ? "code-".concat(id) : _a;
    return {
        id: "id-".concat(id),
        code: code,
        title: "title-".concat(id),
        hidden: !(0, crypto_1.randomInt)(0, 1),
        style: 'default',
        termsConditions: "termsConditions-".concat(id),
        buttonLink: "buttonLink-".concat(id),
        buttonHidden: !(0, crypto_1.randomInt)(0, 1),
        buttonMessage: "buttonMessage-".concat(id),
        promotionType: types_1.PromotionTypes.SearchCard
    };
};
exports.makeSearchCard = makeSearchCard;
